import React from 'react';
import { useHits, useInstantSearch } from 'react-instantsearch';
export default function Hits({ hitComponent: HitComponent, loadingComponent: LoadingComponent, noResultsComponent: NoResultsComponent, hitsSettings, additionalData, }) {
    const { hits } = useHits(hitsSettings);
    const { results } = useInstantSearch();
    // eslint-disable-next-line no-underscore-dangle
    const isLoading = results.__isArtificial;
    const noResults = !isLoading && results.nbHits === 0;
    if (isLoading) {
        return (React.createElement(LoadingComponent, { results: results, loadingSettings: hitsSettings.loading || {}, additionalData: additionalData }));
    }
    if (noResults) {
        return (React.createElement(NoResultsComponent, { results: results, noResultsSettings: hitsSettings.noResults || {}, additionalData: additionalData }));
    }
    return (React.createElement(React.Fragment, null, hits.map((hit) => (React.createElement(HitComponent, { key: hit.objectID, results: results, hit: hit, additionalData: additionalData })))));
}
